import React from 'react'
import { get } from 'lodash'

import { SearchSelect } from '../common/SearchSelect'
import { useListRequest } from '../../hooks/request'
import { DOCUMENT_STATUS } from '../../constants/documentStatus'
import { gridList } from '../../requests/grid'

const getOptionLabel = (o) => o.name
const getOptionValue = (o) => o && o.id

export const GridSelect = ({
  onChange, placeholder, startFilter = [DOCUMENT_STATUS.PUBLISHED], ...rest
}) => {
  const listRequest = useListRequest({
    startFilter: {
      status: startFilter,
    },
    request: gridList,
    start: true,
  })

  const onSearch = listRequest.setSearch

  const options = get(listRequest.state.data, 'docs', [])
  const finalOnChange = (val) => {
    if (val === null) {
      return onChange('')
    }
    onChange(val)
  }

  return (
    <SearchSelect
      isClearable
      clearValue={() => rest.onChange('')}
      onSearch={onSearch}
      translatePlaceholder={!rest.prefilledText}
      placeholder={placeholder || 'lookForGridPlaceholder'}
      getOptionLabel={getOptionLabel}
      getOptionValue={getOptionValue}
      onChange={finalOnChange}
      options={options}
      {...rest}
    />
  )
}
